module.exports = __webpack_public_path__ + "97f228e9ec01e45dec2725612fb762c1.png";